import React from 'react';
import './Solution.css'; // Using the same CSS file since the styles are already defined

const KeyFeatures: React.FC = () => {
  return (
    <section className="key-features-section">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Platform Capabilities</div>
          <h2 className="section-title">Powerful Features for Complex Networks</h2>
        </div>

        <div className="features-grid">
          <div className="feature-item">
            <div className="feature-number">01</div>
            <h3>Network Analysis</h3>
            <p>Interactive graph interface that visualizes complex business networks centered around a specific company, revealing hidden connections, dependencies, and potential risk pathways.</p>
          </div>

          <div className="feature-item">
            <div className="feature-number">02</div>
            <h3>Risk Scoring</h3>
            <p>Advanced algorithmic assessment that evaluates direct and indirect relationships to generate comprehensive credit risk scores, providing deeper insights than traditional credit models.</p>
          </div>

          <div className="feature-item">
            <div className="feature-number">03</div>
            <h3>API Integration</h3>
            <p>Seamlessly integrate our graph intelligence capabilities into your existing systems with robust, secure, and well-documented APIs that support real-time data exchange and analysis.</p>
          </div>

          <div className="feature-item">
            <div className="feature-number">04</div>
            <h3>Watchlist Monitoring</h3>
            <p>Add and track companies of interest to receive alerts on significant changes in their network connections, financial health, or risk profile, enabling proactive risk management.</p>
          </div>

          <div className="feature-item">
            <div className="feature-number">05</div>
            <h3>Rules Engine</h3>
            <p>Custom configurable decision framework that allows you to define and implement your own credit assessment rules, then process companies through these rules for automated credit decisions.</p>
          </div>
          
          <div className="feature-item">
            <div className="feature-number">06</div>
            <h3>Embedded iFrame Components</h3>
            <p>The graph network visualization is available as an iFrame to be integrated in your platform.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;
